export default __webpack_public_path__ + "static/media/research.bfc6ed24.png";